import React from "react";

export const ResultsTabs = ({ activeTab, onTabChange }) => (
	<div className="tabs-container">
		<button
			onClick={() => onTabChange("domains")}
			className={`tab ${activeTab === "domains" ? "tab-active" : "tab-inactive"}`}
			style={
				activeTab === "domains"
					? {
							backgroundColor: "var(--openx-primary)",
							color: "white",
							boxShadow: "0 1px 3px rgba(0, 118, 189, 0.3)",
						}
					: {}
			}
		>
			Domains
		</button>
		<button
			onClick={() => onTabChange("app")}
			className={`tab ${activeTab === "app" ? "tab-active" : "tab-inactive"}`}
			style={
				activeTab === "app"
					? {
							backgroundColor: "var(--openx-primary)",
							color: "white",
							boxShadow: "0 1px 3px rgba(0, 118, 189, 0.3)",
						}
					: {}
			}
		>
			App
		</button>
		<button
			onClick={() => onTabChange("packages")}
			className={`tab ${activeTab === "packages" ? "tab-active" : "tab-inactive"}`}
			style={
				activeTab === "packages"
					? {
							backgroundColor: "var(--openx-primary)",
							color: "white",
							boxShadow: "0 1px 3px rgba(0, 118, 189, 0.3)",
						}
					: {}
			}
		>
			Packages
		</button>
		<button
			onClick={() => onTabChange("audience")}
			className={`tab ${activeTab === "audience" ? "tab-active" : "tab-inactive"}`}
			style={
				activeTab === "audience"
					? {
							backgroundColor: "var(--openx-primary)",
							color: "white",
							boxShadow: "0 1px 3px rgba(0, 118, 189, 0.3)",
						}
					: {}
			}
		>
			Audience
		</button>
		<button
			onClick={() => onTabChange("segments")}
			className={`tab ${activeTab === "segments" ? "tab-active" : "tab-inactive"}`}
			style={
				activeTab === "segments"
					? {
							backgroundColor: "var(--openx-primary)",
							color: "white",
							boxShadow: "0 1px 3px rgba(0, 118, 189, 0.3)",
						}
					: {}
			}
		>
			Segments
		</button>
		<button
			onClick={() => onTabChange("category")}
			className={`tab ${activeTab === "category" ? "tab-active" : "tab-inactive"}`}
			style={
				activeTab === "category"
					? {
							backgroundColor: "var(--openx-primary)",
							color: "white",
							boxShadow: "0 1px 3px rgba(0, 118, 189, 0.3)",
						}
					: {}
			}
		>
			Category Search
		</button>
	</div>
);
